import React from 'react';
import { Icon } from "@blueprintjs/core";
import Classnames from "classnames";
import switchView from '../../../../assets/switchView.png';
import { ReactComponent as DisableIcon } from '../../../../assets/disableIcon.svg';

class PairComparaisonVote extends React.Component {
    render() {
        const { session, instance, className, onVote, votedFor, viewMode, switchViewMode } = this.props;
        const { metadata } = session;
        const {type} = metadata;
        const { data } = session;
        const { sequences = [] } = data;
        const { currentSequence } = instance;
        const sequence = sequences[currentSequence];
        const resourceA = sequence.resources[0] || {};
        const resourceB = sequence.resources[1] || {};
        
        if (type === "AUTONOMOUS" && viewMode === 'double') {
            return (
                <div className={`${className} pc-double-control-display`}>
                    <div className={`${className} pc-double-control-voter sequence-vote-wrapper row pc-piloted-voter`}>
                        <div className="col-xs-12 margin-bottom-medium">
                            <div className="context text-center" id="autonomousText">
                                {metadata.context}
                            </div>
                        </div>
                        <div className="autonomous-pc-vote-container">
                            <div className='btn-pc-double text-center'>
                                <div
                                    className={Classnames({ 'item': true, 'active': votedFor === resourceA.id, 'autonomous': type === "AUTONOMOUS" })}
                                    onClick={() => onVote(resourceA.id)}>
                                    A
                                </div>
                            </div>
                            <div className='btn-pc-double text-center'>
                                <div
                                    className={Classnames({ 'item': true, 'active': votedFor === resourceB.id, 'autonomous': type === "AUTONOMOUS" })}
                                    onClick={() => onVote(resourceB.id)}>
                                    B
                                </div>
                            </div>
                            <div className='btn-pc-double text-center'>
                                <div
                                    className={Classnames({ 'item': true, 'active': votedFor === 'null', 'autonomous': type === "AUTONOMOUS" })}
                                    onClick={() => onVote('null')}>
                                    <DisableIcon className="disableIconSvg" />
                                </div>
                            </div>               
                        </div>
                        <div className='switchButton-container'>
                            <div className='switchButton' onClick={switchViewMode}>
                                <img src={switchView} alt="switchView" className='switchViewIcon' />
                                <p className='switchViewTxt'>Pair/Single</p>
                            </div>
                        </div>       
                    </div>                 
                </div>
            );
        } else {
        return (
            <div className={className}>
                <div className="sequence-vote-wrapper row pc-piloted-voter">
                    <div className="col-xs-12 margin-bottom-medium">
                    <div className={"context text-center"}>
                            {metadata.context}
                        </div>
                    </div>
                    <div className="col-xs-4 text-center">
                        <div
                            className={Classnames({ 'item': true, 'active': votedFor === resourceA.id })}
                            onClick={() => onVote(resourceA.id)}>
                            A
                        </div>
                    </div>
                    <div className="col-xs-4 text-center">
                        <div
                            className={Classnames({ 'item': true, 'active': votedFor === resourceB.id})}
                            onClick={() => onVote(resourceB.id)}>
                            B
                        </div>
                    </div>
                    <div className="col-xs-4 text-center">
                        <div
                            className={Classnames({ 'item': true, 'active': votedFor === 'null'})}
                            onClick={() => onVote('null')}
                            >
                            <Icon icon="disable"/>
                        </div>
                    </div>
                </div>
            </div>
        );
        }
    }
}

export default PairComparaisonVote;